import { createSlice } from "@reduxjs/toolkit";

export const intialReviewLocalState = {
  lead_id: null,
  quote_id: null,
  job_name: null,
  job_id: null,
  date: null,
  description: null,
  source_id: null,
  rating_title: null,
  obtained_from: null,
  link: null,
};

const initialState = {
  users: [],
  reviews: [],
  reviewSource: [],
  leadReviews: [],
  jobCompletionTasks: [],
  complaintCosts: [],
  complaintInProgress: [],
  singleComplaint: null,
  newReviewLocal: intialReviewLocalState,
  pagination: {},
  isAddComplaintCostSuccess: false,
  isAddReviewSuccess: false,
  isUpdateReviewSuccess: false,
  isAddReviewSourceSuccess: false,
  isDeleteComplaintSuccess: false,
  complaintInProgressResponse: false,
  isCrewNotesResponse: false,
  defaultServiceList: [],
  isDefaultServiceResponse: false,
  defaultTaskList: [],
  isDefaultTaskResponse: false,
  leadNotification: null,
  isLeadNotificationUpdateResponse: false,
};

export const reviewSlice = createSlice({
  name: "review",
  initialState,
  reducers: {
    getAllReviwsAction: (state, { payload }) => {},
    setAllReviwsAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, reviews = [] } = payload;
      state.reviews = reviews;
      state.pagination = pagination;
    },

    addReviewAction: (state, { payload }) => {},
    setAddReviewResponse: (state, { payload }) => {
      state.isAddReviewSuccess = payload;
    },

    getLeadReviewAction: (state, { payload }) => {},
    getLeadReviewResponseAction: (state, { payload }) => {
      state.leadReviews = payload;
    },

    updateReviewAction: (state, { payload }) => {},
    setUpdateReviewResponse: (state, { payload }) => {
      state.isUpdateReviewSuccess = payload;
    },

    getAllReviwSourceAction: (state) => {},
    setAllReviwSourceAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, reviewSources = [] } = payload;
      state.reviewSource = payload;
      state.pagination = pagination;
    },

    deleteReviewAction: (state, { payload }) => {},
    setDeleteReviewResponse: (state, { payload }) => {
      state.isUpdateReviewSuccess = payload;
    },

    getJobCompletionTaskAction: (state, { payload }) => {},
    setJobCompletionTaskResponse: (state, { payload }) => {
      state.jobCompletionTasks = payload;
    },

    addReviewSourceAction: (state, { payload }) => {},
    setAddReviewSourceResponse: (state, { payload }) => {
      state.isAddReviewSourceSuccess = payload;
    },

    updateCrewLeadNotesAction: (state, { payload }) => {},
    updatedCrewLeadNotesResponse: (state, { payload }) => {
      state.isCrewNotesResponse = payload;
    },

    setNewReviewLocal: (state, action) => {
      state.newReviewLocal = action.payload;
    },
    resetNewReviewLocal: (state) => {
      state.newReviewLocal = intialReviewLocalState;
    },

    getDefaultServiceListAction: (state) => {},
    setDefaultServiceListResponse: (state, { payload }) => {
      state.defaultServiceList = payload;
    },

    updateDefaultServiceAction: (state, { payload }) => {},
    setUpdateDefaultServiceResponse: (state, { payload }) => {
      state.isDefaultServiceResponse = payload;
    },

    deleteDefaultServiceAction: (state, { payload }) => {},
    setDeleteDefaultServiceResponse: (state, { payload }) => {
      state.isDefaultServiceResponse = payload;
    },

    getDefaultTaskListAction: (state) => {},
    setDefaultTaskListResponse: (state, { payload }) => {
      state.defaultTaskList = payload;
    },

    updateDefaultTaskAction: (state, { payload }) => {},
    setUpdateDefaultTaskResponse: (state, { payload }) => {
      state.isDefaultTaskResponse = payload;
    },

    deleteDefaultTaskAction: (state, { payload }) => {},
    setDeleteDefaultTaskResponse: (state, { payload }) => {
      state.isDefaultTaskResponse = payload;
    },

    getLeadNotificationAction: (state) => {},
    setLeadNotification: (state, { payload }) => {
      state.leadNotification = payload;
    },

    updateLeadNotificationAction: (state, { payload }) => {},
    setUpdateLeadNotificationAction: (state, { payload }) => {
      state.isLeadNotificationUpdateResponse = payload;
    },
  },
});

const {
  getAllReviwsAction,
  setAllReviwsAction,
  addReviewAction,
  setAddReviewResponse,
  getLeadReviewAction,
  getLeadReviewResponseAction,
  updateReviewAction,
  setUpdateReviewResponse,
  deleteReviewAction,
  setDeleteReviewResponse,
  getAllReviwSourceAction,
  setAllReviwSourceAction,
  addReviewSourceAction,
  setAddReviewSourceResponse,
  getJobCompletionTaskAction,
  setJobCompletionTaskResponse,
  setNewReviewLocal,
  updateCrewLeadNotesAction,
  updatedCrewLeadNotesResponse,
  resetNewReviewLocal,
  getDefaultServiceListAction,
  setDefaultServiceListResponse,
  updateDefaultServiceAction,
  setUpdateDefaultServiceResponse,
  deleteDefaultServiceAction,
  setDeleteDefaultServiceResponse,
  getDefaultTaskListAction,
  setDefaultTaskListResponse,
  updateDefaultTaskAction,
  setUpdateDefaultTaskResponse,
  deleteDefaultTaskAction,
  setDeleteDefaultTaskResponse,
  getLeadNotificationAction,
  setLeadNotification,
  updateLeadNotificationAction,
  setUpdateLeadNotificationAction,
} = reviewSlice.actions;

export {
  getAllReviwsAction,
  setAllReviwsAction,
  addReviewAction,
  setAddReviewResponse,
  getLeadReviewAction,
  getLeadReviewResponseAction,
  updateReviewAction,
  setUpdateReviewResponse,
  deleteReviewAction,
  setDeleteReviewResponse,
  getAllReviwSourceAction,
  setAllReviwSourceAction,
  addReviewSourceAction,
  setAddReviewSourceResponse,
  getJobCompletionTaskAction,
  setJobCompletionTaskResponse,
  updateCrewLeadNotesAction,
  updatedCrewLeadNotesResponse,
  setNewReviewLocal,
  resetNewReviewLocal,
  getDefaultServiceListAction,
  setDefaultServiceListResponse,
  updateDefaultServiceAction,
  setUpdateDefaultServiceResponse,
  deleteDefaultServiceAction,
  setDeleteDefaultServiceResponse,
  getDefaultTaskListAction,
  setDefaultTaskListResponse,
  updateDefaultTaskAction,
  setUpdateDefaultTaskResponse,
  deleteDefaultTaskAction,
  setDeleteDefaultTaskResponse,
  getLeadNotificationAction,
  setLeadNotification,
  updateLeadNotificationAction,
  setUpdateLeadNotificationAction,
};

export default reviewSlice.reducer;
